module.exports = __webpack_public_path__ + "img/tinder.332d94c.svg";